import { useState } from "react";

const FormInput = (props) => {

    const { label, errorMessage, onChange, id, ...inputProps } = props;

    return (
        <>
            <input
                className="bodycopy"
                {...inputProps}
                onChange={onChange}     
            />
        </>
    );
};

export default FormInput;